/* eslint-disable */
(function() {
  var $ = require('jquery');

  var $searchInput = $('.tech-search input[type="text"]');

  $searchInput.focus(function() {
    var textWidth = $(this)
      .siblings('.search-text')
      .width();
    $(this)
      .siblings('.search-text')
      .css({
        left: '-' + textWidth + 'px',
      });
  });

  $searchInput.blur(function() {
    if ($(this).val().length > 0) {
      $(this)
        .closest('.inner-search')
        .addClass('typed');
      var textWidth = $(this)
        .siblings('.search-text')
        .width();
      $(this)
        .siblings('.search-text')
        .css({
          left: '-' + textWidth + 'px',
        });
    } else {
      $(this)
        .closest('.inner-search')
        .removeClass('typed');
      $(this)
        .siblings('.search-text')
        .css({
          left: '0px',
        });
    }
  });

  $('.login-box-top').click(function() {
    if ($('.login-box').hasClass('open-box')) {
      $('.login-box').removeClass('open-box');
    }

    $(this)
      .parent()
      .addClass('open-box');
  });

  $('.close-box').click(function() {
    $(this)
      .closest('.login-box')
      .removeClass('open-box');
  });

  $(document).click(function(e) {
    var loginBox = $('.login-box');

    // if the target of the click isn't the container nor a descendant of the container
    if (!loginBox.is(e.target) && loginBox.has(e.target).length === 0) {
      $('.login-box').removeClass('open-box');
    }
  });

  var returnUrl = getParameterByName('returnurl');
  var login = getParameterByName('login');
  var register = getParameterByName('register');

  if (returnUrl.length > 0 || login.length > 0) {
    $('.green-login .login-box-top').click();
  } else if (register.length > 0) {
    $('.reg-box .login-box-top').click();
  }

  $('.expand-login').click(function(e) {
    var $loginBoxTop = $('.green-login .login-box-top');

    if ($loginBoxTop.length) {
      e.preventDefault();
      $loginBoxTop.click();
    }
  });

  function getParameterByName(name) {
    name = name
      .replace(/[\[]/, '\\[')
      .replace(/[\]]/, '\\]')
      .toLowerCase();
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search.toLowerCase());
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
})();
